import MaterialModal from "@material-ui/core/Modal";
import React, { useState } from "react";
import Card from "./Card/Card";
import styled from "styled-components";
import Backdrop from "@material-ui/core/Backdrop";

export default function Modal({
  transition = null,
  children,
  open = false,
  onClose = () => {}
}) {
  let Transition = transition;
  if (!transition) {
    return (
      <MaterialModal
        BackdropComponent={Backdrop}
        open={open}
        onClose={onClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {children}
      </MaterialModal>
    );
  }
  return (
    <MaterialModal
      closeAfterTransition={!!transition}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      open={open}
      onClose={onClose}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Transition in={open}>{children}</Transition>
    </MaterialModal>
  );
}

export function useModal(state = false) {
  const [open, setOpen] = useState(state);
  return {
    props: {
      open: open,
      onClose: () => setOpen(false)
    },
    open: () => setOpen(true),
    close: () => setOpen(false)
  };
}

export const ModalCard = styled(Card)`
  &&&& {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
  }
`;

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
`;
